(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const num = (key, fallback) => {
        const value = parseInt(this.dataset[key], 10);
        return Number.isNaN(value) ? fallback : value;
      };
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const addBusinessDays = (start, days) => {
        const date = new Date(start);
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          if (!skipWeekends || (day !== 0 && day !== 6)) added += 1;
        }
        return date;
      };

      const today = new Date();
      const prodMin = num('productionMin', 2);
      const prodMax = Math.max(prodMin, num('productionMax', 5));
      const shipMin = num('shippingMin', 3);
      const shipMax = Math.max(shipMin, num('shippingMax', 7));

      const readyMin = addBusinessDays(today, prodMin);
      const readyMax = addBusinessDays(today, prodMax);
      const deliveredMin = addBusinessDays(readyMin, shipMin);
      const deliveredMax = addBusinessDays(readyMax, shipMax);

      const locale = this.dataset.locale || undefined;
      const format = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
      const range = (a, b) => (a.toDateString() === b.toDateString() ? format.format(a) : `${format.format(a)} – ${format.format(b)}`);

      const set = (selector, text) => {
        const el = this.querySelector(selector);
        if (el) el.textContent = text;
      };
      set('[data-delivery-range]', range(deliveredMin, deliveredMax));
      set('[data-date-ordered]', format.format(today));
      set('[data-date-ready]', range(readyMin, readyMax));
      set('[data-date-delivered]', range(deliveredMin, deliveredMax));
      this.hidden = false;
    }
  }

  if (!customElements.get('delivery-estimate')) customElements.define('delivery-estimate', DeliveryEstimate);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buzz"] && !Shopify.designMode) return;
  try {
    class ProductBuzz extends HTMLElement {
    connectedCallback() {
      const min = parseInt(this.dataset.min, 10) || 10;
      const max = Math.max(min, parseInt(this.dataset.max, 10) || min);
      const key = `product-buzz-${this.dataset.productId}`;
      const random = () => Math.floor(Math.random() * (max - min + 1)) + min;
      let count;
      try {
        count = parseInt(sessionStorage.getItem(key), 10);
      } catch (error) {}
      if (!count || count < min || count > max) count = random();
      this.countEl = this.querySelector('[data-buzz-count]');
      this.render(count, key);
      this.timer = setInterval(() => {
        const drift = Math.floor(Math.random() * 7) - 3;
        this.render(Math.min(max, Math.max(min, this.current + drift)), key);
      }, 9000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    render(count, key) {
      this.current = count;
      if (this.countEl) this.countEl.textContent = String(count);
      try {
        sessionStorage.setItem(key, String(count));
      } catch (error) {}
    }
  }

  if (!customElements.get('product-buzz')) customElements.define('product-buzz', ProductBuzz);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
    const reveal = () => {
      const hasChart = document.getElementById('product-size-chart');
      document.querySelectorAll('[data-open-size-chart]').forEach((link) => {
        link.hidden = !hasChart;
      });
    };
    reveal();
    new MutationObserver(reveal).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-open-size-chart]');
      if (!link) return;
      const chart = document.getElementById('product-size-chart');
      if (!chart) return;
      event.preventDefault();
      const details = chart.closest('details');
      if (details && !details.open) details.querySelector('summary')?.click();
      requestAnimationFrame(() => (details || chart).scrollIntoView({ behavior: 'smooth', block: 'start' }));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
